<template>
  <DialogWrapper
    class="captcha-dialog"
    titleI18nKey="login.common.placeholder.captcha"
    :isMobile="isMobile"
    :closeOnClickModal="false"
    :width="'500px'"
    :show.sync="isShow"
    :loading="loading"
    :appendToBody="appendToBody"
    :cancelBtnLabel="cancelBtnLabel"
    :cancelBtnLabelI18nKey="cancelBtnLabelI18nKey"
    :saveBtnLabel="saveBtnLabel"
    :saveBtnLabelI18nKey="saveBtnLabelI18nKey"
    @save="onCaptchaDialogConfirmClick"
    @cancel="onCaptchaDialogCancelClick"
  >
    <div class="content-form captcha-form">
      <div class="form-line" :class="errorMessage && 'has-error'">
        <el-input
          v-model="captcha"
          class="line-input"
          :placeholder="$t('login.common.placeholder.captcha')"
          @focus="clearErrorMessage"
          @blur="clearErrorMessage"
          @change="clearErrorMessage"
        ></el-input>
        <div v-show="errorMessage" class="line-tip">{{ errorMessage }}</div>
      </div>
      <div class="form-line">
        <img class="captcha-img" :src="captchaSrc"/>
        <i class="refresh-icon iconfont iconrefresh" @click="onRefreshClick"></i>
      </div>
    </div>
  </DialogWrapper>
</template>

<script>
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'
import { deviceType } from '@/utils/common'

export default {
  components: {
    DialogWrapper
  },
  props: {
    show: {
      type: Boolean,
      default: false,
      required: false
    },
    cancelBtnLabel: {
      type: String,
      required: false
    },
    cancelBtnLabelI18nKey: {
      type: String,
      required: false
    },
    saveBtnLabel: {
      type: String,
      required: false
    },
    saveBtnLabelI18nKey: {
      type: String,
      required: false
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    captchaIndex: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      isMobile: deviceType.isMobile,
      captchaSrc: null,
      captcha: null,
      errorMessage: null,
      loading: false
    }
  },
  computed: {
    isShow: {
      get () {
        return this.show
      },
      set (val) {
        this.$emit('update:show', val)
      }
    }
  },
  created () {

  },
  methods: {
    onRefreshClick () {
      this.captchaSrc = this.$DjangoBaseUrl(`/generate-captcha/${this.captchaIndex}/?ts=${new Date().valueOf()}`)
    },
    async onCaptchaDialogConfirmClick () {
      if (!this.captcha) {
        this.errorMessage = this.$t('login.common.placeholder.captcha')
        return
      }
      this.loading = true
      this.$emit('validateCaptcha', this.captcha, (errorMessage) => {
        this.errorMessage = errorMessage
        this.loading = false
      })
    },
    onCaptchaDialogCancelClick () {
      this.$emit('cancel')
    },
    clearErrorMessage () {
      this.errorMessage = null
    }
  },
  watch: {
    isShow: {
      handler (val) {
        if (val) {
          this.captcha = null
          this.clearErrorMessage()
          this.onRefreshClick()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.captcha-dialog {
  .content-form {
    margin-top: 24px;

    .form-line {
      min-height: 40px;
      margin-bottom: 24px;

      &.has-error {
        margin-bottom: 6px;

        .line-tip {
          padding-left: 0;
          color: #f56c6c;
        }

        .line-input {
          ::v-deep {
            > .el-input__inner {
              border-color: #f56c6c;
            }

            .el-input__inner:hover + .el-input-group__prepend,
            .el-input__inner:hover + .el-input-group__append,
            .el-input-group__prepend,
            .el-input-group__append {
              border-color: #f56c6c;
            }
          }
        }
      }

      .line-input {
        ::v-deep {
          .el-input__inner {
            border-radius: 2px;
            padding-left: 14px;
            padding-right: 35px;
          }
        }
      }

      .line-tip {
        padding-left: 15px;
        font-size: 12px;
        line-height: 18px;
      }
    }
  }

  .captcha-form {
    .captcha-img {
      display: inline-block;
      width: 140.75px;
      height: 48px;
      line-height: 40px;
      vertical-align: middle;
      cursor: pointer;
    }

    .refresh-icon {
      margin-left: 10px;
      font-size: 30px;
      vertical-align: middle;
      cursor: pointer;
    }
  }

  .dialog-footer {
    display: flex;
    justify-content: space-between;

    .cancel-btn {
      border: 1px solid #c0c4cc;
      &:hover, &:focus {
        border-color: #b3e0f0;
      }
    }
  }
}

</style>
